import { Link } from "react-router-dom";
import { useId } from "react";

const LOGO_IMAGE = `${process.env.PUBLIC_URL || ""}/assets/logo-heri-sensei.jpeg`;

export default function Logo({ compact = false }) {
  const wordmarkId = `logo-wordmark-mask-${useId().replace(/:/g, "")}`;

  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center gap-2.5 group" aria-label="Beranda Heri Sensei">
      <span aria-hidden="true" className="relative h-[38px] w-[38px] shrink-0 overflow-hidden rounded-full bg-white">
        <img
          src={LOGO_IMAGE}
          alt=""
          className="absolute max-w-none"
          width="82"
          height="82"
          style={{ left: "-22px", top: "-14px" }}
        />
      </span>
      {!compact && (
        <span aria-hidden="true" className="inline-flex h-[29px] w-[124px] shrink-0 items-center text-ink">
          <svg width="124" height="29" viewBox="0 0 824 190" role="img" aria-label="Heri Sensei">
            <defs>
              <filter id={`${wordmarkId}-invert`} colorInterpolationFilters="sRGB">
                <feColorMatrix type="matrix" values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0" />
              </filter>
              <mask id={wordmarkId} maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse" x="0" y="0" width="824" height="190" mask-type="luminance">
                <image
                  href={LOGO_IMAGE}
                  x="-215"
                  y="-814"
                  width="1254"
                  height="1254"
                  filter={`url(#${wordmarkId}-invert)`}
                />
              </mask>
            </defs>
            <rect width="824" height="190" fill="currentColor" mask={`url(#${wordmarkId})`} />
          </svg>
        </span>
      )}
    </Link>
  );
}
